"use client"
import MainMenu from '@/components/MainMenu'
import { useOrgLogo } from '@/hooks/useOrgLogo'
import { Skeleton } from '@/components/ui/skeleton'
import axiosInstance from '@/lib/axiosInstance'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import React, { useEffect, useState } from 'react'
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from 'react-icons/fa'
import Cookies from 'js-cookie'



export default function Home() {
    const { name: orgName, socialMedia } = useOrgLogo();
    // const router = useRouter()
    // router.push("/dashboard")
    const [listData, setListData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const getBatch = async () => {
            try {
                const response = await axiosInstance.get('api/course',);
                setListData(response?.data?.data)
                setLoading(false)
            } catch (e) {
                setLoading(false)
            }
        }
        getBatch();
    }, [])

    return (
        <div>
            <div className="top_bar flex gap-10 md:gap-0 items-center justify-between pr-2 md:pr-10 py-2 shadow-custom1">
                <MainMenu />
            </div>
            <div className="container min-h-custom-calc pb-4 md:pb-0">
                <h2 className="text-3xl md:text-4xl capitalize font-playfair mt-2 md:my-5">Courses</h2>
                <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-5 mt-5'>
                    {
                        (listData?.length == 0 && loading) && <>
                            {Array.from({ length: 3 }).map((_, index) => (
                                <div key={index} id="courses" className="mt-4">
                                    <div className="md:w-[350px] border rounded-md   text-white">
                                        <Skeleton className="h-[120px]" />
                                    </div>
                                </div>
                            ))}
                        </>
                    }
                    {
                        listData.length > 0 && !loading && listData.map((value: any, index: any) => {
                            return (
                                <div key={`cour-${value?.id}`} className="border rounded-md p-5 text-white bg-[#191654] flex flex-col items-start justify-between">
                                    <div>
                                        <h2 className="font-medium text-3xl my-2">{value.name}</h2>
                                    </div>
                                    <div>
                                        {value?.link ? (
                                            <Link
                                                href={value.link}
                                                target="_blank"
                                                className="uppercase mt-4 py-2 px-4 bg-[#43c6ac] hover:bg-[#60D3BD] inline-block w-fit"
                                            >
                                                Learn More
                                            </Link>
                                        ) : (
                                            <div className="mt-4" />
                                        )}
                                        <Link
                                            href={`/course-details/${value?.slug}`}
                                            className="ml-5 uppercase mt-4 py-2 px-4 bg-[#43c6ac] hover:bg-[#60D3BD] inline-block w-fit"
                                        >
                                            Course Details
                                        </Link>


                                    </div>
                                </div>

                            )
                        })
                    }
                </div >
            </div>
            <div className="bg-[#191654] py-10">
                <div className="container">
                    <div className="grid md:grid-cols-2 gap-2 md:gap-0">
                        <p className="text-white text-center md:text-left">Copyright © 2024 {orgName} of Cardiac Sonography & Health Care Inc.</p>
                        <div className="text-xl text-white flex gap-5 justify-center">
                            {socialMedia.facebookEnabled && socialMedia.facebookUrl && (
                                <Link href={socialMedia.facebookUrl} target="_blank" rel="noopener noreferrer">
                                    <FaFacebook />
                                </Link>
                            )}
                            {socialMedia.twitterEnabled && socialMedia.twitterUrl && (
                                <Link href={socialMedia.twitterUrl} target="_blank" rel="noopener noreferrer">
                                    <FaTwitter />
                                </Link>
                            )}
                            {socialMedia.instagramEnabled && socialMedia.instagramUrl && (
                                <Link href={socialMedia.instagramUrl} target="_blank" rel="noopener noreferrer">
                                    <FaInstagram />
                                </Link>
                            )}
                            {socialMedia.linkedinEnabled && socialMedia.linkedinUrl && (
                                <Link href={socialMedia.linkedinUrl} target="_blank" rel="noopener noreferrer">
                                    <FaLinkedin />
                                </Link>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
// dep
